import { useMemo, useRef, useState } from 'react';
import {
  Experience,
  ExperienceVariant,
  ShopifyOrderTag,
} from '@/webapi/use-experience-api';

const buildTagsDraft = (
  variants: ExperienceVariant[],
  tagsByVariantId: Map<string, string>,
): ShopifyOrderTag[] => [
  { variantId: `original`, label: tagsByVariantId.get(`original`) || `` },
  ...variants.map((v) => ({
    variantId: v.id,
    label: tagsByVariantId.get(v.id) || ``,
  })),
];

export function useShopifyOrderTags(
  currentExperience: Experience,
  variants: ExperienceVariant[],
  toggleShopifyOrderTagging: (toggle: boolean) => void,
  setShopifyOrderTags: (tags: ShopifyOrderTag[]) => void,
) {
  const [showModal, setShowModal] = useState(false);
  const [tagsDraft, setTagsDraft] = useState<ShopifyOrderTag[]>([]);
  const triggerRef = useRef<HTMLDivElement>(null);

  const tagsByVariantId = useMemo(
    () =>
      new Map(
        (currentExperience.shopifyOrderTags || []).map((tag) => [
          tag.variantId,
          tag.label,
        ]),
      ),
    [currentExperience.shopifyOrderTags],
  );

  const openModal = () => {
    setTagsDraft(buildTagsDraft(variants, tagsByVariantId));
    setShowModal(true);
  };

  const onLabelChange = (variantId: string, label: string) => {
    setTagsDraft((prev) =>
      prev.map((tag) =>
        tag.variantId === variantId ? { ...tag, label } : tag,
      ),
    );
  };

  const onSave = () => {
    setShopifyOrderTags(tagsDraft);
    setShowModal(false);
  };

  const onClose = () => {
    setShowModal(false);
    if (!currentExperience.tagShopifyOrders) {
      toggleShopifyOrderTagging(false);
    }
  };

  return {
    showModal,
    tagsDraft,
    triggerRef,
    openModal,
    onLabelChange,
    onSave,
    onClose,
  };
}
